import { render } from "./gerenciador_arquivos.vue?vue&type=template&id=9cc2889c"
import script from "./gerenciador_arquivos.vue?vue&type=script&lang=js"
export * from "./gerenciador_arquivos.vue?vue&type=script&lang=js"

import "./gerenciador_arquivos.vue?vue&type=style&index=0&id=9cc2889c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__